export enum DataType {
	undefined = 0,
	Boolean = 1,
	DateTime = 2,
	Number = 3,
	Integer = 4,
	Map = 5,
	Text = 6,
	TextArea = 7,
	DropDownMenu = 8,
	MultiSelect = 9,
	EditableMap = 10,
}
